<div class="p-d-flex p-jc-between">
    <p-selectButton [options]="allModules" [(ngModel)]="selectedModule" optionLabel="name"
        (onChange)="changeModule()" [unselectable]="true"></p-selectButton>
    <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Search" (input)="dt.filterGlobal($event.target.value, 'contains')" />
    </span>
</div>
<p-table [value]="allCustomFields" #dt [globalFilterFields]="['name','module','formControl.label']">
    <ng-template pTemplate="header">
        <tr>
            <th>Name</th>
            <th>Module</th>
            <th>Field Type</th>
            <th>Required</th>
            <th>Is Active</th>
            <th>Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-field let-i="rowIndex">
        <tr>
            <td>{{field.name}}</td>
            <td>{{field.module}}</td>
            <td>{{field.formControl?.label}}</td>
            <td>{{field.isRequired?answertypeConstants.Yes:answertypeConstants.No}}</td>
            <td>{{field.statusId==statusConstants.ACTIVE?answertypeConstants.Yes:answertypeConstants.No}}</td>
            <td class="action">
                <span class="btnBars p-mr-0" *ngIf="field.isEdit && selectedModule?.name!=crudRemoveModuleName"
                    (click)="showEditCustomFieldPopUp(field)" pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                <span class="btnBars p-mr-0" *ngIf="field.isDelete && selectedModule?.name!=crudRemoveModuleName"
                    (click)="deleteCustomField(field)" pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
            </td>
            <td *ngIf="allCustomFields.length == 0"> No Records found </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="{{addEditCustomFieldHeader}}" [modal]="true" [(visible)]="displayAddEditCustomField"
    [style]="{width: '50vw'}" [baseZIndex]="10000">
    <form [formGroup]="customFieldForm">
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-lg-6">
                    <label for="name">Module Name <span style="color: red;">*</span></label>
                    <p-dropdown [options]="addUpdateModules" formControlName="objectId" optionLabel="name"
                        [readonly]="!isCustomFieldAdd" [ngClass]="{'p-disabled': !isCustomFieldAdd}"
                        placeholder="Select Module" appendTo="body" (onChange)="changeModuleDropdown($event)" required>
                    </p-dropdown>
                </div>

                <div class="p-col-12 p-lg-6">
                    <label for="name">Section Name <span style="color: red;">*</span></label>
                    <p-dropdown [options]="sections" formControlName="section" optionLabel="name"
                        placeholder="Select Section" appendTo="body">
                    </p-dropdown>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-lg-6">
                    <label for="name">Title <span style="color: red;">*</span></label>
                    <input type="text" pInputText formControlName="fieldName" [readonly]="!isCustomFieldAdd" [ngClass]="{'p-disabled': !isCustomFieldAdd}">
                    <small *ngIf="showCustomFieldValidation && customFieldNameExist" class="p-invalid">
                        Field name already exists
                    </small>
                    <small *ngIf="customFieldForm.get('fieldName').hasError('alphaNumeric')" class="p-invalid">
                        Only alphabets, numbers, spaces, hyphens, and underscores are allowed.
                    </small>
                </div>
                <div class="p-col-12 p-lg-6">
                    <label for="name">Field Type <span style="color: red;">*</span></label>
                    <p-dropdown [options]="showAllCustomFieldTypes" formControlName="formControlId" optionLabel="label"
                        placeholder="Select Field Type" [filter]="true" appendTo="body" (onChange)="resetPickList($event)"
                        [readonly]="!isCustomFieldAdd" [ngClass]="{'p-disabled': !isCustomFieldAdd}">
                    </p-dropdown>
                    <small *ngIf="showCustomFieldValidation && showOptionValidationError" class="p-invalid">
                        <span *ngIf="([formControls.DropDownList,formControls.MultipleDropDownList,formControls.CheckBox].includes(customFieldForm.controls['formControlId'].value.id)) && pickListValues.length==0">
                            At least 1 option is required
                        </span>
                        <span *ngIf="(customFieldForm.controls['formControlId'].value.id == formControls.RadioButton) && pickListValues.length<2">
                            Atleast 2 options are required
                        </span>
                    </small>
                </div>
                @if(customFieldForm.controls['formControlId'].value?.id == formControls.Currency){
                    <div class="p-col-12 p-lg-6">
                        <label for="name">Currency<span style="color: red;">*</span></label>
                        <p-dropdown [options]="currencies" formControlName="currencyId" optionLabel="name"
                            placeholder="Select Currency"  [filter]="true" appendTo="body" optionValue="id"
                            >
                        </p-dropdown>
                        <!-- <small *ngIf="showCustomFieldValidation && showOptionValidationError" class="p-invalid">
                            <span *ngIf="(customFieldForm.controls['formControlId'].value.id == formControls.RadioButton) && pickListValues.length<2">
                                Atleast 2 options are required
                            </span>
                        </small> -->
                    </div>
                }
                
            </div>                        
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-6" *ngIf="customFieldForm.controls['formControlId'].value && (customFieldForm.controls['formControlId'].value.id == formControls.Decimal)">
                    <div class="p-field">
                        <label for="name">Max Length After Decimal
                            <i *ngIf="!isCustomFieldAdd" class="pi pi-info-circle p-mr-1" aria-hidden="true"
                                pTooltip="Reducing the number of decimal places may result fixed down and potential loss of precision when updating {{ customFieldForm.value.objectId?.name||'' }}."
                                tooltipPosition="right"></i>
                            <span style="color: red;">*</span>
                        </label>
                        <p-inputNumber formControlName="maxLengthAfterDecimal" [min]="1" [max]="6" (keypress)="isNumberKey($event)"></p-inputNumber>
                        <div>
                            <small *ngIf="showCustomFieldValidation && showOptionValidationError" class="p-invalid">
                                <span *ngIf="(customFieldForm.controls['formControlId'].value.id == formControls.Decimal && !customFieldForm.controls['maxLengthAfterDecimal'].value)">
                                    Max length after decimal should between 1 to 6</span>
                            </small>
                        </div>
                    </div>
                </div>

                <div class="p-col-6" *ngIf="customFieldForm.controls['formControlId'].value && (customFieldForm.controls['formControlId'].value.id == formControls.EncryptedText)">
                    <div class="p-field">
                        <label for="name">Display Length <span style="color: red;">*</span></label>
                        <p-inputNumber formControlName="displayLength" (keypress)="isNumberKey($event)"></p-inputNumber>
                        <div *ngIf="detailsFormErrors?.displayLength" class="p-invalid">
                            <small>{{ detailsFormErrors?.displayLength }}</small>
                        </div>
                    </div>
                </div>

                <div class="p-col-6" *ngIf="customFieldForm.controls['formControlId'].value && (customFieldForm.controls['formControlId'].value.id == formControls.Barcode)">
                    <div class="p-field">
                        <label for="name">Barcode Type <span style="color: red;">*</span></label>
                        <p-dropdown [options]="barcodeTypes"
                            formControlName="type" optionLabel="name" optionValue="value"
                            placeholder="Select Barcode Type" appendTo="body">
                        </p-dropdown>
                        <div *ngIf="detailsFormErrors?.type" class="p-invalid">
                            <small>{{ detailsFormErrors?.type }}</small>
                        </div>
                        <div>
                            <small *ngIf="showCustomFieldValidation && showOptionValidationError && !customFieldForm.value?.type" class="p-invalid">
                                Select any barcode type
                            </small>
                        </div>
                    </div>
                </div>

                <div class="p-col-6" *ngIf="customFieldForm.controls['formControlId'].value && (customFieldForm.controls['formControlId'].value.id == formControls.Formula)">
                    <div class="p-field">
                        <label for="name">Expression <span style="color: red;">*</span></label>

                        <span class="text-input-prefix with-edit-icon p-input-icon-right w-100">
                            <span class="prefix">=</span>
                            <i class="p-d-flex p-ai-center">
                                <i *ngIf="customFieldForm.value.expression" (click)="loadExpressionAvailableFields()" class="pi pi-pencil cursor-pointer" pTooltip="Edit Expression"></i>
                                <i *ngIf="!customFieldForm.value.expression" (click)="loadExpressionAvailableFields()" class="pi pi-plus cursor-pointer" pTooltip="Add Expression"></i>
                                <i (click)="removeExpression()" class="pi pi-trash cursor-pointer p-ml-2" pTooltip="Remove Expression"></i>
                            </i>
                            <input pInputText type="text" formControlName="expression" placeholder="Add Formula Expression" [readOnly]="true" />
                        </span>
                        <div *ngIf="detailsFormErrors?.expression" class="p-invalid">
                            <small>{{ detailsFormErrors?.expression }}</small>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="customFieldForm.controls['formControlId'].value && (customFieldForm.controls['formControlId'].value.id == formControls.AutoNumber)">

                    <div class="p-col-4">
                        <div class="p-field">
                            <label>Prefix <span style="color: red;">*</span></label>
                            <input type="text" (input)="customFieldForm.get('prefix').setValue($event.target.value.toUpperCase())" (keypress)="characterOnly($event)" formControlName="prefix" tooltipPosition="top"
                                pInputText>
                            <div *ngIf="detailsFormErrors?.prefix" class="p-invalid">
                                <small>{{ detailsFormErrors?.prefix }}</small>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-4">
                        <div class="p-field">
                            <label>Starting No. <span style="color: red;">*</span></label>
                            <input [ngClass]="{'custom_invalid' : customFieldForm['errors']?.numberRangeInvalid}"
                                (keypress)="numberOnly($event)" formControlName="startingSequenceNumber" required pInputText>

                            <div *ngIf="customFieldForm['errors']?.numberRangeInvalid" class="p-invalid">
                                <small> Starting No. cannot be greater than Ending No.</small>
                            </div>

                            <div *ngIf="detailsFormErrors?.startingSequenceNumber" class="p-invalid">
                                <small>{{ detailsFormErrors?.startingSequenceNumber }}</small>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-4">
                        <div class="p-field">
                            <label>Ending No. <span style="color: red;">*</span></label>
                            <input required (keypress)="numberOnly($event)" formControlName="endingSequenceNumber" pInputText>

                            <div *ngIf="detailsFormErrors?.endingSequenceNumber" class="p-invalid">
                                <small>{{ detailsFormErrors?.endingSequenceNumber }}</small>
                            </div>
                        </div>
                    </div>
                </ng-container>


                <div class="p-col-12 p-field-checkbox" style="align-items: flex-end;">
                    <p-checkbox formControlName="isRequired" [ngStyle]="{verticalAlign: 'middle' }" binary="true" inputId="isRequired"></p-checkbox>
                    <label for="isRequired" style="padding: 5px;margin:0px">Required</label>
                </div>
                <div class="p-col-12 p-field-checkbox" style="align-items: flex-end;" *ngIf="fieldId === 8">
                    <p-checkbox formControlName="isAppend" [ngStyle]="{verticalAlign: 'middle' }" binary="true"
                        inputId="isAppend"></p-checkbox>
                    <label for="isAppend" style="padding: 5px;margin:0px">Append</label>
                </div>
                <ng-container *ngIf="[2].includes(customFieldForm?.get('objectId')?.value?.id)">
                    <div *ngIf="showProjectSection " class="p-col-12 p-field-checkbox" style="align-items: flex-end;">
                        <p-checkbox formControlName="isProjected" [ngStyle]="{verticalAlign: 'middle' }" binary="true" inputId="isProjected" (onChange)="onProjectedCheckboxChange($event)"></p-checkbox>
                        <label for="isProjected" style="padding: 5px;margin:0px">Is Projected</label>
                    </div>
                </ng-container>
                
                <div class="p-col-12"
                    *ngIf="customFieldForm.controls['formControlId'].value && (customFieldForm.controls['formControlId'].value.id == formControls.DropDownList
            || customFieldForm.controls['formControlId'].value.id == formControls.CheckBox ||
            customFieldForm.controls['formControlId'].value.id == formControls.RadioButton || customFieldForm.controls['formControlId'].value.id == formControls.MultipleDropDownList)">
                    <div class="p-field p-grid">
                        <div class="p-col-10" style="font-size: 14px;">
                            <span
                                *ngIf="customFieldForm.controls['formControlId'].value.id == formControls.DropDownList"><label
                                    style="padding: 5px;margin:0px;font-weight: 600;">Add DropDown
                                    List</label></span>
                            <span
                                *ngIf="customFieldForm.controls['formControlId'].value.id == formControls.MultipleDropDownList"><label
                                    style="padding: 5px;margin:0px;font-weight: 600;">Add Multi-Select
                                    List</label></span>
                            <span
                                *ngIf="customFieldForm.controls['formControlId'].value.id == formControls.CheckBox"><label
                                    style="padding: 5px;margin:0px;font-weight: 600;">Add CheckBox</label></span>
                            <span
                                *ngIf="customFieldForm.controls['formControlId'].value.id == formControls.RadioButton"><label
                                    style="padding: 5px;margin:0px;font-weight: 600;">Add Radio
                                    Buttons</label></span>
                        </div>
                        <div pButton (click)="addOptionList()" class="p-col-2 p-button-text
                p-button-rounded" style="margin-left: 7px;" label="" icon="pi pi-plus"></div>
                    </div>
                    <div *ngIf="pickListValues.length>0">
                        <ng-container *ngFor="let option of pickListValues;let
                i= index;">
                            <div class="p-field p-grid">
                                <div class="p-col-10">
                                    <input pInputText type="text" [(ngModel)]="option.name" name="option{{i}}"
                                        [ngModelOptions]="{standalone: true}" required>
                                    <small *ngIf="showCustomFieldValidation && !option.name" class="p-invalid">
                                        Option name is required
                                    </small>
                                </div>
                                <div class="p-col-2">
                                    <div pButton (click)="deleteCustomOption(i)" class="p-button-text p-button-rounded"
                                        label="" icon="pi pi-minus">
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    </div>
            <div class="p-col-12" *ngIf="isProjectedEnabled && showProjectSection">
                <div  class="p-field p-grid">
                    <div class="p-col-10" style="font-size: 14px;">
                        <span><label style="padding: 5px;margin:0px;font-weight: 600;">Add Projected Module</label></span>
                    </div>
                    @if(projectedFields?.length < 1){ 
                        <div pButton (click)="addProjectedField()" class="p-col-2 p-button-text
                                            p-button-rounded" style="margin-left: 7px;" label="" icon="pi pi-plus">
                        </div>
                        }
                </div>
                <div formArrayName="projectedFields" *ngIf="isProjectedEnabled">
                    <div *ngFor="let field of projectedFields.controls; let i=index">
                        <div [formGroupName]="i" class="p-field p-formgrid p-grid">
                            <div class="p-col-10 p-lg-5">
                                <label for="targetModule">Target Module <span style="color: red;">*</span></label>
                                <p-dropdown [options]="targetModulesOptions" formControlName="targetModuleId" optionLabel="name"
                                    placeholder="Select Module" optionValue="id" appendTo="body"
                                    (onChange)="changeTargetModuleDropDown($event, i)" required>
                                </p-dropdown>
                            </div>
                            <div class="p-col-10 p-lg-5">
                                <label for="targetSection">Target Section <span style="color: red;">*</span></label>
                                <p-dropdown [options]="targetModulesSection[i]" optionValue="id" formControlName="targetSectionId"
                                    optionLabel="name" placeholder="Select Section" appendTo="body" required>
                                </p-dropdown>
                            </div>
                            <div class="p-col-2 p-lg-1 align-label">
                                <div pButton  (click)="removeProjectedField(i)" class="p-button-text p-button-rounded p-mt-4" label=""
                                    icon="pi pi-minus">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="displayAddEditCustomField = false; fieldId = null;" label="Cancel"
            class="p-button-secondary"></button>
        <button pButton [disabled]="!customFieldForm.valid" (click)="saveCustomFieldData()" label="Save"></button>
    </ng-template>
</p-dialog>

<app-add-fields-expression-dialog
    *ngIf="displayAddExpression"
    [displayAddExpression]="displayAddExpression"
    [expressionText]="expressionText"
    [availableFieldsForExpression]="availableFieldsForExpression"
    (expressionSaved)="saveExpression($event)"
    (dialogClosed)="expressionDialogClose()"
>
</app-add-fields-expression-dialog>
